module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcBAMAAACAI8KnAAAAKlBMVEUAAADS0tLQ0NDPz8/Q0NDQ0NDPz8/Pz8/Q0NDQ0NDPz8/Ozs7R0dHMzMz/PW47AAAADnRSTlMAQOfF+NjQy4l9a1QhGchOLasAAACGSURBVBjTYwABxmYVJwsBBijgDpt4gVcydQOEx2MOlmAsPgDmCi2ACHMpgkVBJEQcpOoQ3AxGHSBhxQAHi4HGFiC47BsYWAUQXMYABjEGJJDI0InMncFgiMwVZtBF5l5icEDmsqBx0RSjGYVmEZoz0ByJ5gVUD6J5Hy1wUIMOLWAxgh0tUgDxcRrVz9GqxAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/disagree@2x.png
// module id = NETV
// module chunks = 1